import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};


import * as filterCounter from './scripts/filter-counter';
filterCounter.init();

import * as genericSlider from './scripts/generic-slider';
genericSlider.init();

//bootstrap imports
import Collapse from 'bootstrap/js/dist/collapse';

import * as accordion from './scripts/accordion.js';
accordion.init();

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();
